export default __webpack_public_path__ + "static/media/team-member-4.d9d42557.png";